import { ModuleUebersicht, type ModuleCfg } from './ModuleUebersicht';

const cfg: ModuleCfg = {
  path: 'laser_kant',
  label: 'Laser/Kant',
  breadcrumb: 'Produktion (unabhängig)',
  extraColumns: [
    { key: 'lackieren',  label: 'Lack' },
    { key: 'ral_farbe',  label: 'RAL' },
  ],
};

export function LaserKant() {
  return <ModuleUebersicht cfg={cfg} />;
}
